import {Injectable, Injector} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {
    WidgetImplementation,
    WidgetImplementationEvent,
    WidgetImplementationEventFlags
} from '../../components/layout/widget/widget-implementation';
import {
    getWidgetSettingsWithUpdatesStream,
    setWidgetSettings,
    updateWidgetSettings
} from '../components/common-widget.implementation';
import {EmptyWidgetSettings, EmptyWidgetSettingsService} from './settings';

@Injectable()
export class EmptyWidgetImplementation implements WidgetImplementation {

    public settings: EmptyWidgetSettings;

    public readonly settingsService: EmptyWidgetSettingsService = this.injector.get(EmptyWidgetSettingsService);

    public ready$ = new BehaviorSubject<boolean>(false);
    public event$ = new Subject<WidgetImplementationEvent>();
    public settingsWithUpdates$: Observable<Partial<EmptyWidgetSettings>> =
               getWidgetSettingsWithUpdatesStream(this);

    constructor(
        private injector: Injector
    ) {}

    public setSettings(
        settings?: EmptyWidgetSettings,
        flags?: WidgetImplementationEventFlags
    ): Observable<EmptyWidgetSettings> {
        return setWidgetSettings(this, settings, flags);
    }

    public updateSettings(
        updates?: Partial<EmptyWidgetSettings>,
        flags?: WidgetImplementationEventFlags
    ): Observable<Partial<EmptyWidgetSettings>> {
        return updateWidgetSettings(this, updates, flags);
    }

}
